module.exports = (fox) => {

	var _ = {
		getTranslation: function(alias) {
			var translation = {
				'proceed': fox.i18n.getTranslation('proceed', 'Proceed', 'dialog'),
				'cancel': fox.i18n.getTranslation('cancel', 'Cancel', 'dialog')
				};
			return translation[alias] || '';
		}
	};

	fox.registerWidget('Security_Popup_Forgot', {
		configure() {
			this.registerOptions('', {
				contentTemplate: 'popup_security_forgot',
				onOkPress: (...args) => this.onCancel(),
				dialog: {
					close: () => this.onCancel(),
					width: '390px',
					title: 'Data protection',
					buttons: [{
						text: 'Got It!',
						click: function () {},
						class: 'mc-btn btn-small btn-casual',
						id: 'on-success'
					}],
				},
			}),
			this.callParent('configure', arguments);
		},
		onCancel() {
			this.securityData = fox.site.wom1('~.Security_Data');
			this.securityData.dispatchEvent('cancelPopup');
			this.hide();

			return fox.Promise.resolve(false);
		}
	}, 'GDPR_BasePopup');
}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/security-payment-details/widget/forgotPopup.es.js